import { render, staticRenderFns } from "./LinksList.vue?vue&type=template&id=78ca5f57&"
import script from "./LinksList.vue?vue&type=script&lang=ts&"
export * from "./LinksList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports